'use client';

import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import React from 'react';
import { Button } from 'src/components/PulseUI';
import { useDrawer } from 'src/hooks/drawers/useDrawer';

const StrategyInfoButton = () => {
  const { openDrawer } = useDrawer();

  const handleClick = () => {
    openDrawer('strategy-info');
  };

  return (
    <Button
      variant="soft"
      color="neutral"
      size="md"
      startIcon={faInfoCircle}
      onClick={handleClick}
      className="h-9 bg-neutral-100 hover:bg-neutral-200 [&>span]:!justify-center [&>span]:gap-2 [&>span>span:first-child]:pl-0 [&_svg]:text-sm rounded-full text-neutral-800 font-bold"
    >
      Strategy Info
    </Button>
  );
};

export default StrategyInfoButton;
